/**
 * Created by roman.kupin on 2/20/2018.
 */

import * as StoriesActions from "../actions/index";
import * as PropertyApiActions from "../../../actions/propertyApi";

export default function storiesReducer(state = {
    isInitialized: false,
    isShowNewLibrary: true,
    isCompletedRecommendation: false
}, { type, payload }) {
    switch (type) {
        case StoriesActions.INITIALIZED: {
            return Object.assign({}, state, { isInitialized: payload });
        }
        case StoriesActions.TOGGLE_NEW_LIBRARY: {
            return Object.assign({}, state, { isShowNewLibrary: payload });
        }
        case PropertyApiActions.RECOMMENDATIONS_FETCH_SUCCESS: {
            const recommendations = payload;
            const topRecommendation = !!recommendations && !!recommendations.length ? recommendations[0] : null;
            return Object.assign({}, state, { recommendations, topRecommendation });
        }
        case StoriesActions.STORIES_DATA_FETCH_SUCCESS: {
            const
                popularStories = payload[0],
                broadcastWorthyStories = payload[1],
                broadcastWorthyQuotes = payload[2],
                commonKeywords = payload[3],
                recommendations = payload[4];

            const quoteOfTheDay = !!broadcastWorthyQuotes.Total ? broadcastWorthyQuotes.Quotes[0] : null;

            const topRecommendation = !!recommendations && !!recommendations.length ? recommendations[0] : null;

            return Object.assign({}, state, { isInitialized: true, quoteOfTheDay, broadcastWorthyStories, popularStories, broadcastWorthyQuotes, commonKeywords, recommendations, topRecommendation });
        }
        default: {
            return state;
        }
    }
}